/**
 * @desc 生成调拨单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(body: Array<string>, options?: any) {
  return updateResponse(
    http(URL + `/allocationPlan/create`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
